import { StyleSheet, View } from "react-native";
import RText from "../../../RText";
import variables from "../../../../styles/variables";

const { colors } = variables;

type Props = {
  children: string;
  fontSize?: "xs" | "sm";
};

/**
 * Prompt component displays a styled text prompt with a background.
 * It is used to show additional information or instructions in a concise format.
 *
 * @component
 * @param {string} children - The text content to display inside the prompt.
 * @param {string} [props.fontSize="xs"] - The font size of the text, defaults to "xs".
 *
 * @returns {JSX.Element} The rendered prompt component.
 */
const Prompt = ({ children, fontSize = "xs" }: Props) => {
  return (
    <View style={styles.container}>
      <RText size={fontSize}>{children}</RText>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: colors.palette.neutral.x100,
    borderRadius: 24,
    paddingHorizontal: 16,
    paddingVertical: 4,
    lineHeight: 1.5,
    width: "100%",
  },
});
export default Prompt;
